import gsap, { Power1 } from "gsap";
import React from "react";
import Common from "./Common";
import CheckFairness from "./windows/CheckFairness";
import { Controller } from "./core/Controller";

import "./History.css";
import { Comm } from "./core/comm/Comm";

export default class History extends React.Component<History.Props, History.State>
{

    refView: React.RefObject<HTMLDivElement>;
    ref: React.RefObject<HTMLDivElement>;
    animateNext: boolean = false;
    tween: GSAPTween;
    style: {
        width: number,
        scale: number,
        translate: number
    };

    constructor(props: History.Props)
    {
        super(props);

        this.state = {
            open: false,
            multipliers: []
        };

        this.onWindowDown = this.onWindowDown.bind(this);
    }


    add(data: Comm.ResponseTypes.History)
    {
        if (this.state.multipliers.find(m => m.game_round_id == data.game_round_id))
        {
            return;
        }

        this.state.multipliers.unshift(data);

        if (this.state.multipliers.length > 50)
        {
            this.state.multipliers.pop();
        }

        if (this.tween)
        {
            this.tween.progress(1);
        }

        this.animateNext = !this.state.open;
        this.setState({
            multipliers: this.state.multipliers
        });
    }


    buttonClick()
    {
        this.setState({
            open: !this.state.open
        });
    }


    checkFairness(id: string)
    {
        app.addWindow(<CheckFairness
            roundId={id}
        />)
    }


    render()
    {

        const lang = window.lang.shared;

        return (
            <div
                id="history"
                className={this.state.open ? "open" : ""}
                ref={this.refView}
            >
                <div className="wrapper">
                    <div className="head">
                        <div className="title font_upper">
                            {lang["round_history"]}
                        </div>
                        {this.renderHistoryNumbers(!this.state.open)}
                        <div
                            className="button"
                            onClick={this.buttonClick.bind(this)}
                        >
                            <div className="icon_history"></div>
                            <div className="icon_arrow_down"></div>
                            <div className="shadow"></div>
                        </div>
                    </div>

                    {this.renderHistoryNumbers(this.state.open)}
                </div>

            </div>
        );
    }


    componentDidMount()
    {
        this.ref = React.createRef();
        this.refView = React.createRef();

        Comm.on(Comm.RESPONSE.INITIALIZE, this.onInit, this);
        Comm.on(Comm.RESPONSE.GAME_STATE_CRASH, this.onCrash, this);

        window.addEventListener("click", this.onWindowDown);
    }


    componentWillUnmount()
    {
        Comm.off(Comm.RESPONSE.INITIALIZE, this.onInit, this);
        Comm.off(Comm.RESPONSE.GAME_STATE_CRASH, this.onCrash, this);

        window.removeEventListener("click", this.onWindowDown);
    }


    onWindowDown(event: MouseEvent)
    {
        if (this.state.open)
        {
            let el = event.target as HTMLElement;
            while (el)
            {
                if (el == this.refView.current)
                {
                    return;
                }
                el = el.parentNode as HTMLElement;
            }

            this.setState({
                open: false
            });
        }
    }


    onInit(data: Comm.ResponseTypes.Init)
    {
        if (this.tween)
        {
            this.animateNext = false;
            this.tween.progress(1);
        }

        this.setState({
            multipliers: data.game.history.slice(0, 25)
        });
    }


    onCrash(data: Comm.ResponseTypes.GameState)
    {
        setTimeout(() => {
            this.add({
                result: Controller.multiplier,
                game_round_id: Controller.gameRoundId,
                timestamp: Common.getTimestamp()
            });
        }, 500);
    }


    componentDidUpdate(prevProps: Readonly<History.Props>, prevState: Readonly<History.State>, snapshot?: any): void
    {
        if (prevState.open !== this.state.open && this.tween)
        {
            this.tween.progress(1);
        }

        if (this.ref.current && this.animateNext)
        {
            this.animateNext = false;

            this.style = {
                width: 0,
                scale: 2,
                translate: 12
            };

            this.tween = gsap.to(this.style, {
                duration: .75,
                width: this.ref.current.clientWidth,
                translate: 0,
                scale: 1,
                onUpdate: this.updateStyle.bind(this),
                onComplete: this.updateStyleComplete.bind(this),
                ease: Power1.easeInOut
            });
        }
    }


    updateStyle()
    {
        this.ref.current.style.width = this.style.width + "px";
        this.ref.current.style.transform = "scale(" + this.style.scale + ") translateX(" + this.style.translate + "px)";
    }


    updateStyleComplete()
    {
        this.tween = null;
        this.ref.current.style.width = null;
        this.ref.current.style.transform = null;
    }


    renderHistoryNumbers(render: boolean)
    {
        if (!render)
        {
            return;
        }

        const arr = [] as Array<JSX.Element>;

        this.state.multipliers.forEach((num, i, a) =>
        {
            arr.push(
                <div
                    className="item"
                    ref={i === 0 ? this.ref : null}
                    style={{
                        opacity: i === 0 ? 1 : Math.max(.95 - i * .05, .5)
                    }}
                    key={"history_" + num.game_round_id}
                    onClick={this.checkFairness.bind(this, num.game_round_id)}
                >
                    {Common.renderMultiplier(Number(num.result))}
                </div>
            );
        });

        return (
            <div className="list">
                {arr}
            </div>
        );
    }


}


export namespace History
{


    export interface Props
    {

    }


    export interface State
    {

        multipliers: Array<Comm.ResponseTypes.History>;
        open: boolean;

    }


}